<template>
  <SuccessModal :showSuccessModal="state.showSuccessModal" :closeModal="handleSuccessModal" :data="successModalData" />
  <section class="sales-rep-form">
    <div
        class="modal fade"
        id="salesRepModal"
        tabindex="-1"
        aria-labelledby="salesRepModalLabel"
        aria-hidden="true"
        :class="[show ? ['d-block', 'show'] : '']"
    >
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
          <button
              type="button"
              class="btn-nulled text-secondary fw-bold position-absolute btn-close-custom"
              aria-label="Close"
              @click="handleCloseModalForm"
          >CLOSE</button>
          <div class="modal-header d-flex align-items-center flex-column border-0">
            <img :src="modal.company.logo.link" :alt="modal.company.logo.alt" />
            <ButtonRed type="submit" :text="modal.company.phone.text" id="salesRepModalLabel" :phone="modal.company.phone.number" />
          </div>
          <div class="modal-body">
            <p class="h2 text-primary text-center">{{modal.title}}</p>
            <div v-html="modal.description" class="modal-desc" />
            <form>
              <div class="form-section">
                <p class="h4">{{ modal.form.aboutYou.title }}</p>
                <div class="d-grid columns">
                  <div>
                    <label for="firstName">{{ modal.form.aboutYou.firstName.label }}</label>
                    <Input
                        :placeholder="modal.form.aboutYou.firstName.placeholder"
                        id="firstName"
                        v-model="state.firstName"
                        class="w-100"
                        :warning="v$.firstName.$error"
                    />
                    <span v-if="v$.firstName.$error" class="d-inline-block mt-1 text-secondary">{{ v$.firstName.$errors[0].$message }}</span>
                  </div>
                  <div>
                    <label for="lastName">{{ modal.form.aboutYou.lastName.label }}</label>
                    <Input
                        :placeholder="modal.form.aboutYou.lastName.placeholder"
                        v-model="state.lastName"
                        :warning="v$.lastName.$error"
                    />
                    <span v-if="v$.lastName.$error" class="d-inline-block mt-1 text-secondary">{{ v$.lastName.$errors[0].$message }}</span>
                  </div>
                  <div>
                    <label for="role">{{ modal.form.aboutYou.role.label }}</label>
                    <Input :placeholder="modal.form.aboutYou.role.placeholder" id="role" v-model="state.role" />
                  </div>
                  <div>
                    <label for="phone">{{ modal.form.aboutYou.phone.label }}</label>
                    <Input :placeholder="modal.form.aboutYou.phone.placeholder" id="phone" v-model="state.phone" />
                  </div>
                  <div>
                    <label for="email">{{ modal.form.aboutYou.email.label }}</label>
                    <Input
                        :placeholder="modal.form.aboutYou.email.placeholder"
                        v-model="state.email"
                        :warning="v$.email.$error"
                    />
                    <span v-if="v$.email.$error" class="d-inline-block mt-1 text-secondary">{{ v$.email.$errors[0].$message }}</span>
                  </div>
                </div>
              </div>
              <div class="form-section">
                <p class="h4">{{ modal.form.aboutYourOrg.title }}</p>
                <div class="d-grid columns">
                  <div>
                    <label for="company">{{ modal.form.aboutYourOrg.companyName.label }}</label>
                    <Input
                        :placeholder="modal.form.aboutYourOrg.companyName.placeholder"
                        id="company"
                        v-model="state.company"
                        :warning="v$.company.$error"
                    />
                    <span v-if="v$.company.$error" class="d-inline-block mt-1 text-secondary">{{ v$.company.$errors[0].$message }}</span>
                  </div>
                  <div>
                    <label>{{ modal.form.aboutYourOrg.industry.label }}</label>
                    <Select
                        :options="state.industryOptions"
                        v-model="state.industry"
                        :placeholder="modal.form.aboutYourOrg.industry.placeholder"
                        :searchable="false"
                        :warning="v$.industry.$error"
                    />
                  </div>
                  <div>
                    <label for="city">{{ modal.form.aboutYourOrg.city.label }}</label>
                    <GMapAutocomplete
                        :placeholder="modal.form.aboutYourOrg.city.placeholder"
                        @place_changed="(location) => handleLocation(state, location, false, false, usaStates,canadaStates)"
                        :class="{
                            'item-danger': v$.city.$error,
                            'active': state.isActive && !v$.city.$error
                        }"
                        class="input autocomplete-input"
                        :options="state.autocompleteOptions"
                        :value="state.city"
                        @focus="() => changeInputStatus(state, 'isActive')"
                        @blur="() => changeInputStatus(state, 'isActive')"
                        @input="(e) => handleAutocomplete(state, e)"
                    >
                    </GMapAutocomplete>
                  </div>
                  <div>
                    <label>{{ modal.form.aboutYourOrg.state.label }}</label>
                    <v-select
                        :options="state.stateOptions"
                        class="select-standard"
                        :class="{'item-danger': v$.state.$error}"
                        :searchable="false"
                        :placeholder="modal.form.aboutYourOrg.state.placeholder"
                        v-model="state.state"
                    />
                  </div>
                  <div>
                    <label>{{ modal.form.aboutYourOrg.country.label }}</label>
                    <v-select
                        label="title"
                        :options="state.countryOptions"
                        class="select-standard"
                        :class="{'item-danger': v$.country.$error}"
                        :searchable="false"
                        :placeholder="modal.form.aboutYourOrg.country.placeholder"
                        @option:selected="(option) => handleSelected(option, 'country', false, state ,usaStates, canadaStates)"
                        v-model="state.country"
                    />
                  </div>
                  <div class="col-12">
                    <label for="source">{{ modal.form.aboutYourOrg.source.label }}</label>
                    <Input :placeholder="modal.form.aboutYourOrg.source.placeholder" id="source" v-model="state.source" />
                  </div>
                </div>
              </div>
              <div class="form-section">
                <p class="h4">{{ modal.form.aboutLocationForThisProduct.title }}</p>
                <div class="d-grid columns">
                  <div>
                    <label for="aboutLocationForThisProductAdress">{{ modal.form.aboutLocationForThisProduct.address.label }}</label>
                    <GMapAutocomplete
                        :placeholder="modal.form.aboutLocationForThisProduct.address.placeholder"
                        @place_changed="(location) => handleLocation(state, location, true, true, usaStates,canadaStates)"
                        :class="{
                            'active': state.isActiveAddress
                        }"
                        class="input autocomplete-input"
                        :options="state.addressAutocompleteOptions"
                        :value="state.aboutTheLocation.address"
                        @focus="() => changeInputStatus(state, 'isActiveAddress')"
                        @blur="() => changeInputStatus(state, 'isActiveAddress')"
                        @input="(e) => handleAutocomplete(state, e, 'address')"
                    >
                    </GMapAutocomplete>
                  </div>
                  <div>
                    <label for="aboutLocationForThisProductAdressAdditional">{{ modal.form.aboutLocationForThisProduct.addressAdditional.label }}</label>
                    <Input
                        :placeholder="modal.form.aboutLocationForThisProduct.addressAdditional.placeholder"
                        id="aboutLocationForThisProductAdressAdditional"
                        v-model="state.aboutTheLocation.addressAdditional"
                    />
                  </div>
                  <div>
                    <label for="aboutLocationForThisProductCity">{{ modal.form.aboutLocationForThisProduct.city.label }}</label>
                    <GMapAutocomplete
                        :placeholder="modal.form.aboutLocationForThisProduct.city.placeholder"
                        @place_changed="(location) => handleLocation(state, location, true, false, usaStates,canadaStates)"
                        :class="{
                            'active': state.isActiveAdditional
                        }"
                        class="input autocomplete-input"
                        :options="state.autocompleteOptions"
                        :value="state.aboutTheLocation.city"
                        @focus="() => changeInputStatus(state, 'isActiveAdditional')"
                        @blur="() => changeInputStatus(state, 'isActiveAdditional')"
                        @input="(e) => handleAutocomplete(state, e, 'aboutTheLocation')"
                    >
                    </GMapAutocomplete>
                  </div>
                  <div>
                    <label>{{ modal.form.aboutLocationForThisProduct.state.label }}</label>
                    <v-select
                        :options="state.aboutTheLocation.stateOptions"
                        class="select-standard"
                        :searchable="false"
                        :placeholder="modal.form.aboutLocationForThisProduct.state.placeholder"
                        v-model="state.aboutTheLocation.state"
                    />
                  </div>
                  <div>
                    <label>{{ modal.form.aboutLocationForThisProduct.country.label }}</label>
                    <v-select
                        :options="state.aboutTheLocation.countryOptions"
                        class="select-standard"
                        :searchable="false"
                        :placeholder="modal.form.aboutLocationForThisProduct.country.placeholder"
                        @option:selected="(option) => handleSelected(option, 'country', true, state, usaStates, canadaStates)"
                        v-model="state.aboutTheLocation.country"
                    />
                  </div>
                  <div>
                    <label for="aboutLocationForThisProductZip">{{ modal.form.aboutLocationForThisProduct.zip.label }}</label>
                    <Input
                        :placeholder="modal.form.aboutLocationForThisProduct.zip.placeholder"
                        id="aboutLocationForThisProductZip"
                        v-model="state.aboutTheLocation.zip"
                    />
                  </div>
                </div>
              </div>
              <div class="form-section">
                <p class="h4">{{ modal.form.requirements.title }}</p>
                <div class="col-12 d-flex flex-column">
                  <label for="aboutLocationForThisProductTextarea">{{ modal.form.requirements.textarea.label }}</label>
                  <TextArea
                      id="aboutLocationForThisProductTextarea"
                      :class="{ 'active': state.textarea.focus }"
                      @focus="handleTextarea(state, true)"
                      @blur="handleTextarea(state, false)"
                      v-model="state.textarea.value"
                      :placeholder="modal.form.requirements.textarea.placeholder"
                  />
                </div>
                <div class="col-12 d-flex align-items-center checkbox-email">
                  <Checkbox v-model:checked="state.subscribeEmail" id="confirmReceivingEmailsCheckbox" class="bg-white me-2" />
                  <p>{{ modal.form.checkbox}}</p>
                </div>
                <div class="col-12 d-flex justify-content-center ">
                  <ButtonRed
                      :loading="isLoading"
                      :disabled="isLoading"
                      :text="modal.form.button.text"
                      @click="handleSubmit"
                      :type="null"
                      class="btn-confirm"
                  />
                </div>
              </div>
            </form>
          </div>
          <ErrorBlock v-if="defineFormError(v$)" :errors="defineFormError(v$)" />
        </div>
      </div>
    </div>
  </section>
</template>

<script>
  import {computed, reactive, watch} from 'vue';
  import ButtonRed from "@/components/common/ButtonRed";
  import Input from "@/components/common/Input";
  import Select from "@/components/common/Select";
  import Checkbox from "@/components/common/Checkbox";
  import ErrorBlock from "@/components/common/ErrorBlock";
  import SuccessModal from "@/components/common/modals/SuccessModal";
  import useLoadData from "@/composables/useLoadData";
  import {useReCaptcha} from "vue-recaptcha-v3";
  import {contactUsValidationOptions, defineFormError} from "@/utils/validators";
  import {useVuelidate} from "@vuelidate/core";
  import {
    defineFormData,
    defineStateOptions,
    handleLocation,
    handleSelected,
    clearForm,
    getModalFormRecaptcha,
    handleTextarea,
    changeInputStatus,
    handleAutocomplete
  } from "@/utils/utils";
  import TextArea from "@/components/common/TextArea";
  import {addressAutocompleteOptions, autocompleteOptions} from "@/config/config";
  import api from "@/config/api";
  import {formsProps} from "@/config/props/forms";
  import submitFormToGa from "@/utils/submitFormToGa";

export default {
  components: {ButtonRed, Checkbox, Select, Input, ErrorBlock, TextArea, SuccessModal},
  data(){
    return {
      defineFormError,
      handleLocation,
      handleSelected,
      clearForm,
      handleTextarea,
      changeInputStatus,
      handleAutocomplete
    }
  },
  props: {
    modal: {
      company: {
        logo: {
          link: String,
          alt: String
        },
        phone: {
          text: String,
          number: String
        }
      },
      title: String,
      description: HTMLElement,
      form: formsProps
    },
    successModalData: {
      logo: {
        link: String,
        alt: String
      },
      title: String,
      description: String,
      buttonText: String
    },
    show: Boolean
  },
  emits: ['handleModal'],
  setup(props){
    const { fetchData: sendForm, isLoading } = useLoadData()
    const { executeRecaptcha, recaptchaLoaded } = useReCaptcha()
    const {
      countryOptions,
      industryOptions,
      usaStates,
      canadaStates
    } = defineFormData(props)


    const state = reactive({
      showSuccessModal: false,
      firstName: '',
      lastName: '',
      role: '',
      phone: '',
      email: '',
      company: '',
      industry: '',
      industryOptions,
      state: '',
      stateOptions: countryOptions && defineStateOptions(countryOptions, usaStates, canadaStates),
      city: '',
      country: countryOptions && countryOptions[0],
      countryOptions,
      source: '',
      aboutTheLocation: {
        address: '',
        addressAdditional: '',
        city: '',
        state: '',
        country: countryOptions && countryOptions[0],
        zip: '',
        stateOptions: countryOptions && defineStateOptions(countryOptions, usaStates, canadaStates),
        countryOptions
      },
      textarea: {
        focus: false,
        value: ''
      },
      subscribeEmail: false,
      autocompleteOptions,
      addressAutocompleteOptions,
      isActive: false,
      isActiveAdditional: false
    })

    const recaptcha = async () => {
      isLoading.value = true;
      const formName = props.modal?.form?.name || ''
      const data = { ...getModalFormRecaptcha(state, formName) }

      // (optional) Wait until recaptcha has been loaded.
      await recaptchaLoaded()

      // Execute reCAPTCHA with action "login".
      const recaptchaToken = await executeRecaptcha('login')

      await sendForm({
        url: api.formSubmit,
        method: 'post',
        data: {
          ...data,
          recaptchaToken
        }
      })

      submitFormToGa(formName);
    }

    let rules = computed(() => contactUsValidationOptions);

    const v$ = useVuelidate(rules, state);

    watch(() => props.show, () => {
      const main = document.querySelector('main');

      document.querySelector('body').classList.toggle('overflow-hidden')
      main.style.zIndex = (window.getComputedStyle(main).zIndex === 'auto' ? '1300' : 'auto')
    })

    return {
      state,
      handleSelected,
      v$,
      recaptcha,
      usaStates,
      canadaStates,
      countryOptions,
      isLoading
    }
  },
  methods: {
    async handleSubmit(){
      await this.v$.$validate()

      if(!this.v$.$error && !this.isLoading) {
        this.recaptcha();
        this.$emit('handleModal')
        this.state.showSuccessModal = true
      }
    },
    handleSuccessModal()  {
      this.state.showSuccessModal = false
      this.clearForm(this.state, this.v$, this.countryOptions[0])
    },
    handleCloseModalForm () {
      this.$emit('handleModal')
      this.clearForm(this.state, this.v$, this.countryOptions[0])
    }
  }
}
</script>
